export const CATALOG = [
  {
    id: "cat_thinking_fast_slow",
    title: "Thinking, Fast and Slow",
    author: "Daniel Kahneman",
    category: "Psikologi & Nalar",
    pages: 499,
    price: 189000,
    stock: 14,
    texture: "/images/texture-1.jpg",
    description:
      "Kahneman memaparkan dua sistem berpikir: Sistem 1 yang cepat dan intuitif, serta Sistem 2 yang lambat dan analitis. Buku ini membahas bias kognitif, heuristik, dan cara keputusan kita sering menyimpang dari nalar.",
    topics: ["Bias kognitif", "Heuristik", "Pengambilan keputusan"],
  },
  {
    id: "cat_filosofi_teras",
    title: "Filosofi Teras",
    author: "Henry Manampiring",
    category: "Stoisisme",
    pages: 346,
    price: 98000,
    stock: 22,
    texture: "/images/texture-2.jpg",
    description:
      "Pengantar Stoisisme dalam konteks keseharian orang Indonesia: dikotomi kendali, mengelola emosi negatif, dan hidup selaras dengan nalar serta kebajikan.",
    topics: ["Dikotomi kendali", "Emosi", "Kebajikan"],
  },
  {
    id: "cat_meditations",
    title: "Meditations",
    author: "Marcus Aurelius",
    category: "Klasik Stoik",
    pages: 254,
    price: 85000,
    stock: 0,
    texture: "/images/texture-1.jpg",
    description:
      "Catatan pribadi Kaisar Marcus Aurelius kepada dirinya sendiri: refleksi tentang kefanaan, kewajiban, dan ketenangan batin. Teks klasik Stoik yang ringkas namun padat.",
    topics: ["Kefanaan", "Kewajiban", "Ketenangan batin"],
  },
];

import { read } from "@/lib/storage";

export const getBook = (id) =>
  read("books").find((b) => b.id === id) || CATALOG.find((b) => b.id === id) || null;

export const normTitle = (t) => (t || "").toLowerCase().replace(/[^a-z0-9]+/g, " ").trim();

export const matchCatalog = (title) => {
  const n = normTitle(title);
  if (!n) return null;
  return CATALOG.find((c) => normTitle(c.title) === n || n.includes(normTitle(c.title)) || normTitle(c.title).includes(n)) || null;
};

export const rupiah = (n) => "Rp" + Math.round(n).toLocaleString("id-ID");
